import { EntityGetRequest, EntityListRequest } from '#/protobuf/service_query_pb';
import { EntityInfoExpansionRequest } from '#/protobuf/entity_pb';

import { EntityId } from '#/protobuf/general_pb';
import { EntitiesSearchParameters, QueryInt64 } from '#/protobuf/query_pb';
import { EntityType } from '#/protobuf/enums_pb';

export const DEFAULT_PAGE_SIZE = 15;

function FreshEntityExpansionRequest() {
  const request = new EntityInfoExpansionRequest();
  request.setShouldExpandMetadata(true);
  request.setShouldExpandTags(true);
  request.setShouldExpandJobMembership(true);
  request.setRequestDownloads(true);
  request.setRequestDerivatives(true);
  request.setRequestDerivativeDownloads(true);
  request.setRequestOriginEntities(true);
  request.setRequestOriginDownloads(true);
  return request;
}

function FreshEntityDownloadOnlyRequest(size, checksum) {
  // entities we want
  const entityId = FreshEntityId(size, checksum);
  const request = new EntityGetRequest();
  request.setEntityIdsList([entityId]);

  // flag that we want downloads for the originals and their derivatives
  const expansion = new EntityInfoExpansionRequest();
  request.setRequestDownloads(true);
  request.setRequestDerivatives(true);
  request.setRequestDerivativeDownloads(true);
  request.setExpansionRequest(expansion);

  return request;
}

function FreshEntitySearchParams() {
  const params = new EntitiesSearchParameters();
  // TODO: should this include more than just video?
  // TODO: why again do we use queryInt64 custom type here instead of entity type?
  const entityType = new QueryInt64();
  entityType.setSearchExact(EntityType.ENTITY_TYPE_VIDEO);
  params.setEntityType(entityType);
  return params;
}

export function FreshEntityListRequest() {
  const request = new EntityListRequest();
  request.setCursor(0);
  request.setLimit(DEFAULT_PAGE_SIZE);
  request.setExpansionRequest(FreshEntityExpansionRequest());
  request.setSearchTerms(FreshEntitySearchParams());
  // const entityExpansion = new EntityInfoExpansionRequest();
  // entityExpansion.setShouldExpandThumbnail(true);
  // const expansionRequest = new JobInfoQueryExpansionRequest();
  // expansionRequest.setShouldExpandKeyEntity(entityExpansion);
  // expansionRequest.setShouldExpandReports(true);
  // request.setExpansionRequest(expansionRequest);
  // TODO: add search params back in
  // const searchParams = this.searchParameters();
  // if (searchParams !== null) {
  //   request.setSearchTerms(searchParams);
  // }
  return request;
}

export function FreshEntityId(size, checksum) {
  const entityId = new EntityId();
  entityId.setSize(size);
  entityId.setChecksum(checksum);
  return entityId;
}

export function FreshEntityGetRequest(entityIds) {
  if (!entityIds || entityIds.length === 0) {
    throw (new Error('cannot create entity get request without list of entity ids.'));
  }
  const request = new EntityGetRequest();
  request.setEntityIdsList(entityIds);
  const expansion = FreshEntityExpansionRequest();
  request.setExpansionRequest(expansion);
  return request;
}